// Helpers for split transactions (one bank transaction, several parts).
import { TRANSACTION_TYPE_OPTIONS } from './transactionTypes';

// Split parts cannot be adjustments (the split table allows the four core types).
export const PART_TYPES = TRANSACTION_TYPE_OPTIONS.filter((t) => t.value !== 'adjustment');
const CHUNK = 500;

export const toCents = (v) => Math.round(Number(v || 0) * 100);

// Cents still to assign (positive) or over-assigned (negative).
export function remainingCents(parentAmount, parts) {
  const used = parts.reduce((sum, p) => sum + toCents(p.amount), 0);
  return Math.abs(toCents(parentAmount)) - used;
}

export function partProblem(part) {
  if (toCents(part.amount) <= 0) return 'Each part needs an amount above zero';
  if (!part.category_id && part.transaction_type !== 'transfer') return 'Only transfer parts can go without a category';
  return null;
}

// Loan payment: principal goes to the loan account (a transfer part whose other
// side lands there), interest is an expense. Returns the parts, or null when
// the numbers do not fit the payment.
export function loanPaymentParts(parentAmount, { loanAccountId, principal, interest, interestCategoryId }) {
  const p = toCents(principal);
  const i = toCents(interest);
  if (!loanAccountId || p < 0 || i < 0 || p + i !== Math.abs(toCents(parentAmount))) return null;
  const parts = [];
  if (p > 0) parts.push({ transaction_type: 'transfer', category_id: '', amount: (p / 100).toFixed(2), memo: 'Principal', counter_account_id: String(loanAccountId) });
  if (i > 0) parts.push({ transaction_type: 'expense', category_id: interestCategoryId ? String(interestCategoryId) : '', amount: (i / 100).toFixed(2), memo: 'Interest', counter_account_id: '' });
  return parts.length === 2 ? parts : null;
}

// The interest category to pre-select: "Interest Expense" (any case), if present.
export function findInterestExpense(categories) {
  return (categories || []).find((c) => c.type === 'expense' && String(c.name).trim().toLowerCase() === 'interest expense') || null;
}

// "Business Income income 600.00; Transfer transfer 400.00"
export function splitSummary(parts) {
  return (parts || [])
    .map((p) => `${p.category_name || 'No category'} ${p.transaction_type} ${Number(p.amount).toFixed(2)}`)
    .join('; ');
}

// Adds `splits` (array) to each row that has parts. Looks them up in chunks.
export async function attachSplits(rows, splitsFor) {
  const ids = rows.map((r) => r.id).filter(Boolean);
  if (!ids.length) return rows;
  const found = {};
  for (let i = 0; i < ids.length; i += CHUNK) {
    const res = await splitsFor(ids.slice(i, i + CHUNK));
    Object.assign(found, res?.data || {});
  }
  return rows.map((r) => (found[r.id] ? { ...r, splits: found[r.id] } : r));
}
